const SendIcon = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="14" height="14" viewBox="0 0 14 14"
		fill="none" stroke="currentColor"
		{...props}
	>
		<path d="M12 7L4 3V11L12 7Z" strokeWidth="2" strokeLinejoin="bevel"/>
	</svg>
)

export default SendIcon